import { render, staticRenderFns } from "./EventContainerGradient.vue?vue&type=template&id=38fa9b06&"
import script from "./EventContainerGradient.vue?vue&type=script&lang=js&"
export * from "./EventContainerGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports